import {
  type TableColumnFormatObject,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import {
  ARRAY_CELL_MAX_ITEMS,
  maybeWrapWithMore,
} from 'components/Table/cells/helpers/trimLargeArray';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';

export const renderObjectCell = <TRow,>(
  format: TableColumnFormatObject<TRow, unknown>,
  { row }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  return {
    content: pipe(
      getValueFromKeyOfType(row, format.field),
      (content) =>
        Array.isArray(content)
          ? pipe(
              content,
              (a) => a.slice(0, ARRAY_CELL_MAX_ITEMS),
              array.map(format.toWebString),
              (a) => a.join(', '),
              maybeWrapWithMore(content),
            )
          : format.toWebString(content),
      (content) => (content === '' ? null : content),
    ),
  };
};
